<script setup>
const route = useRoute()
useCustomMeta('area', getAreaPrefectureName(route.params.area))
const breadCrumbList = getBreadCrumb(route.params.area)
const { data: mapPosition } = await useFetch('/api/wind/mapConfig', { query: { path: route.params.area } })
if (!getAreaPrefectureName(route.params.area)) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid Path'
  })
}
</script>

<template>
  <div>
    <NuxtLayout
      name="custom"
      :bread-crumb-list="breadCrumbList"
      :area="getAreaPrefectureName(route.params.area)"
      :area-roma="route.params.area"
    >
      <div class="frame">
        <WindMap
          :map-position="mapPosition"
          :title="getAreaPrefectureName(route.params.area)"
        />
      </div>
      <template #main-bottom>
        <WindPrefList :area="route.params.area" />
      </template>
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.ads-btf1-sp {
  min-height: 50px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}
</style>
